import React from 'react';

import cn from 'classnames';
import { motion } from 'motion/react';

interface Props {
  className?: string;
  width?: number;
  height?: number;
}

const Loader: React.FC<Props> = ({ className, width = 50, height = 50 }) => {
  return (
    <motion.svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.3 }}
      className={cn(className, {
        'text-gray-3': !className?.includes('text-'),
      })}
    >
      <motion.path
        d="M20.527764,13.617419c-3.247092,0-7.156771,3-7.156771,7.056613s3.14,7.483387,7.311171,7.483387c4.5428,0,7.248829-3.814471,7.248829-7.483387c0-2.343432-1.671234-4.716613-1.671234-4.716613s-5.351234,5.749045-5.351234,5.749045-2.737532-2.509045-2.737532-2.509045"
        clipRule="evenodd"
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeDasharray="200"
        strokeDashoffset="200"
        style={{ scale: 1.6 }}
        animate={{
          strokeDashoffset: 0,
          opacity: [1, 0.5, 1, 0.5, 1],
        }}
        transition={{
          strokeDashoffset: {
            duration: 2,
            ease: 'easeInOut',
            repeat: Infinity,
            repeatType: 'reverse',
            repeatDelay: 0.4,
          },
          opacity: {
            delay: 1,
            duration: 2,
            ease: 'linear',
            repeat: Infinity,
            repeatType: 'reverse',
            repeatDelay: 2.8,
          },
        }}
      />
    </motion.svg>
  );
};

export default Loader;
